import { useMemo } from "react";
import { create } from "zustand";
import {
  useOrgContextStore,
  useVisibleSpacePaths,
} from "@/components/main/stores/orgContextStore";
import { filterSpaces } from "./spaceFilter";

interface SpacesFilterState {
  /// The rail's Spaces row is this field while a string, its label while null.
  query: string | null;
  /// The match ↵ opens, as an index into the matches.
  active: number;
  open: () => void;
  setQuery: (query: string) => void;
  setActive: (active: number) => void;
  close: () => void;
}

export const useSpacesFilterStore = create<SpacesFilterState>((set) => ({
  query: null,
  active: 0,
  open: () => set({ query: "", active: 0 }),
  setQuery: (query) => set({ query, active: 0 }),
  setActive: (active) => set({ active }),
  close: () => set({ query: null, active: 0 }),
}));

export function useSpaceFilterResult() {
  const query = useSpacesFilterStore((s) => s.query);
  const paths = useVisibleSpacePaths();
  return useMemo(() => filterSpaces(paths, query), [paths, query]);
}

/// A pick ends the filter on the tree, opened, so the picked row is in view.
export function endFilterOnTree(): void {
  useSpacesFilterStore.getState().close();
  useOrgContextStore.getState().openTree();
}
